import { render, staticRenderFns } from "./PTagInput.vue?vue&type=template&id=852feb8e&"
import script from "./PTagInput.vue?vue&type=script&lang=js&"
export * from "./PTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports